import { ChevronDownIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { faqs } from "../data";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-white text-gray-900">
      <div className="container px-5 py-16 mx-auto lg:w-2/3">
        <h1 className="text-4xl sm:text-5xl font-bold title-font text-gray-900 mb-10 text-center">
          Frequently Asked Questions
        </h1>
        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = index === openIndex;
            return (
              <div
                key={faq.question}
                className="bg-purple-50 rounded-xl border border-purple-100 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full flex items-center justify-between text-left px-6 py-4 focus:outline-none"
                >
                  <span className="text-gray-900 font-medium title-font">
                    {faq.question}
                  </span>
                  <ChevronDownIcon
                    className={`w-5 h-5 text-purple-600 flex-shrink-0 ml-4 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <p className="text-gray-600 text-sm leading-relaxed px-6 pb-5">
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
